// rem等比适配配置文件
// 基准大小：与 postcss-pxtorem 的 rootValue(75) 保持一致，1920 宽下根字号=75px，1rem=设计稿 75px
const baseSize = 75
// 移动端断点：低于此宽度时不再等比缩小，恢复真实像素，便于借助媒体查询重排成移动布局
const MOBILE_BREAKPOINT = 768

// 设置 rem 函数
function setRem () {
  // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
  const clientWidth = document.documentElement.clientWidth
  // 移动端（手机/小屏）：固定根字号为 75px，与 pxtorem 的 rootValue 对齐，让所有 px 以 1:1 呈现
  if (clientWidth <= MOBILE_BREAKPOINT) {
    document.documentElement.style.fontSize = baseSize + 'px'
    return
  }
  const scale = clientWidth / 1920
  // 缩放上限设为 1：超过 1920 设计宽度后不再放大，保证内容区与固定 max-width 的轮播图等区块始终对齐；
  // 否则超宽屏（如 2560 显示器）会把内容区放大到 1440*scale，而内联写死的轮播区仍是 1440px，导致两者错位。
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 1) + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
}
